import { Component, OnInit } from '@angular/core';
import { ClickhouseService } from '../../../shared/services/clickhouse.service';
import { ProcessingService } from '../../../shared/services/processing.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
})
export class SuccessComponent implements OnInit {
  status = '';

  constructor(
    private clickHouse: ClickhouseService,
    private processingService: ProcessingService,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    if (window.localStorage.getItem('order_uuid') || this.route.snapshot.queryParams.order_uuid) {
      this.processingService
        .checkOrderStatus(
          window.localStorage.getItem('order_uuid') || this.route.snapshot.queryParams.order_uuid,
        )
        .subscribe((response: any) => {
          this.status = response.status;
          if (response.status === 'success') {
            this.clickHouse.storeEvent('landing_success_page').subscribe(() => {});
          } else {
            this.clickHouse.storeEvent('landing_fail_payment_page').subscribe(() => {});
          }
          this.spinner.hide();
        });
    }
  }

  continueBtnClick() {
    if (this.status === 'success') {
      this.clickHouse.storeEvent('landing_success_page_click').subscribe(() => {});
    } else {
      this.clickHouse.storeEvent('landing_fail_payment_page_retry').subscribe(() => {});
    }
    this.router.navigate(['']).then(() => {});
  }
}
